export interface Paginator {
  previousPageIndex: number;
  pageIndex: number;
  pageSize: number;
  length: number;
}

export interface QcResponseGrid {
  messages: [{ type: string; description: string; code: number }];
  payload: { data: any[]; filterResults: any };
  success: boolean;
}

export enum ActiveComponent {
  SearchTags = 'SearchTagsComponent',
  TagAssignment = 'TagAssignmentComponent',
  SearchBrand = 'SearchBrandComponent',
  SearchIntegration = 'SearchComponent',
  CreateNewIntegration = 'CreateNewIntegrationComponent',
  DetailsIntegration = 'DetailsComponent',
  SearchBulk = 'SearchBulkComponent',
  BulkHistory = 'BulkHistoryComponent',
  UserSearch = 'UserSearchComponent',
  UserPolicyDocuments = 'UserPolicyDocumentsComponent',
  UserSecurityGroups = 'UserSecurityGroupsComponent',
  Invoices = 'InvoicesComponent',
  SearchCheckbooks = 'SearchCheckbooksComponent',
  SearchGroupTemplates = 'SearchGroupTemplatesComponent',
  MerchantSearch = 'MerchantSearchComponent',
  ClubSearch = 'ClubsSearchComponent',
  Lists = 'ListsComponent',
  CampaignExecutions = 'CampaignExecutionsComponent',
  LiteralsSearch = 'LiteralsSearchComponent',
  ImportExportLiterals = 'ImportExportLiteralsComponent',
  CardBatchesSearch = 'CardBatchesComponent',
  Schemas = 'SchemasComponent',
  Tickets = 'TicketsSearchComponent',
  Flows = 'FlowsSearchComponent',
  FlowRecipes = 'FlowRecipesSearchComponent',
  MemberSearch = 'MemberSearchComponent',
  AllCustomers = 'AllCustomersComponent',
  RedeemRules = 'RedeemRulesComponent',
  CampaignSearch = 'CampaignSearchComponent',
}

export enum ActionColumnsLiterals {
  BulkSearch = 'Bulk Actions',
}

export enum ActiveTabIndex {
  SearchComponent = 0,
  CreateNewIntegrationComponent = 1,
  DetailsComponent = 2,
}
